exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".right-side-menu[data-v-ee763952]{min-width:180px;height:100%;background:#fff;border-left:1px solid #f0f0f0}.menu-title[data-v-ee763952]{padding:16px 16px 12px 16px;font-size:16px;font-weight:600;color:#303133;border-bottom:1px solid #f0f0f0;background:#fafafa;border-right:1px solid #f0f0f0}.menu-list[data-v-ee763952]{height:100%}.menu-list .el-menu-item[data-v-ee763952]{height:48px;line-height:48px;padding:0 16px;color:#303133;font-size:14px}.menu-list .el-menu-item.is-active[data-v-ee763952]{background-color:#ecf5ff;color:#409eff;font-weight:600}", ""]);

// exports
